import { Analytics } from './analytics';

let footerSocialMediaLink = $('[data-social-media-tracker-follower-link]');

footerSocialMediaLink.click((e) => {
    Analytics.sendEvent(`Follow Us - ${$(e.currentTarget).attr('title')}`, window.location.pathname, '')
});